import * as R from 'ramda';
import React, { useState, useCallback } from 'react';
// helpers/constants
import * as G from '../helpers';
// utilities
import { sendRequest } from '../utilities/http';
//////////////////////////////////////////////////

const useDataFilter = (props) => {
  const { showErrMsg, emptyData, setEmptyData, asyncMethod, asyncEndpoint } = props;

  const [asyncData, setAsyncData] = useState({ data: null, error: false, loading: true });

  const setLoading = useCallback(() => {
    setAsyncData((prev) => ({ ...prev, loading: true }));
  }, []);

  const getFilteredDataRequest = useCallback(async (options, endpoint) => {
    const res = await sendRequest(asyncMethod, R.or(endpoint, asyncEndpoint), options);

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      if (G.isNotNil(data)) {
        setAsyncData((prev) => ({ ...prev, data, loading: false }));
      } else if (setEmptyData) {
        setAsyncData((prev) => ({ ...prev, data: emptyData, loading: false }));
      }
    } else {
      if (setEmptyData) {
        setAsyncData((prev) => ({ ...prev, data: emptyData, loading: false }));
      }

      G.handleFailResponseSimple(
        res,
        R.or(showErrMsg, false),
        'withDataFilter -> getFilteredDataRequest',
      );
    }
  }, [asyncMethod, asyncEndpoint]);

  return { asyncData, setLoading, getFilteredDataRequest };
};

export const withDataFilterHoc = (Component) => (props) => {
  const dataFilter = useDataFilter(props);

  return <Component {...props} {...dataFilter} />;
};
